import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectLocationZoomSettings = (state: RootState) =>
	state?.mapSettings?.locationZoomSettings;
